import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
function OrderList() {

  const [orders, setOrders] = useState([]);
  useEffect(() => {
    getBookins()
  }, [])

  const token = localStorage.getItem("token");
  const userData = localStorage.getItem("user") ?? null;

  const getBookins = async () => {

    const userId = userData ? JSON.parse(userData).id : null;

    const API_URL = process.env.REACT_APP_API_URL;

    const res = await fetch(`${API_URL}/booking-list`,{
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    const medicines = await res.json();
    
    setOrders(medicines.data)
  }
  return (
    <>
      <Helmet>
        <title>My Orders | Clinic</title>
      </Helmet>
      <div className="page-title">

      </div>
      <section className="container">
        <div className="card shadow-sm border-0">
          <div className="card-body" style={{ backgroundColor: '#f8f9fa' }}>

            <h4 className="fw-semibold mb-4">My Orders</h4>

            {orders.length === 0 ? (
              <div className="text-center py-5 text-muted">
                No Orders Found
              </div>
            ) : (

              orders.map(order => (

                <div key={order.id} className="border rounded p-3 mb-4">

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6 className="mb-1 fw-bold">
                        Order ID: #{order.id}
                      </h6>
                      <small className="text-muted">
                        {order.order_date ? new Date(order.order_date).toLocaleString() : ""}
                      </small>
                    </div>

                    <div>
                      <span className="fw-semibold text-primary">
                        Total: ${order.grand_total}
                      </span>
                    </div>
                  </div>

                  {order.items.map(item => (
                    <div key={item.id} className="row align-items-center border-top py-2">

                      <div className="col-md-6">
                        <h6 className="mb-0">{item.name}</h6>
                      </div>

                      <div className="col-md-3 text-md-center">
                        Qty: {item.quantity}
                      </div>

                      <div className="col-md-3 text-md-end fw-semibold">
                        ${(item.price * item.quantity).toFixed(2)}
                      </div>

                    </div>
                  ))}

                </div>

              ))

            )}

          </div>
        </div>
      </section>
    </>
  );
}


export default OrderList;
